import { Button, ButtonProps } from 'antd'
import React, { useState } from 'react'
import { fetchBillingPortalUrl } from '../../services/ProfileBillingService'

interface BillingPortalButtonProps {
  profileSlug: string
}

export const BillingPortalButton: React.FC<
  BillingPortalButtonProps & ButtonProps
> = ({ profileSlug, ...rest }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)

  return (
    <Button
      {...rest}
      loading={isLoading}
      disabled={isLoading}
      onClick={() => {
        setIsLoading(true)
        fetchBillingPortalUrl(profileSlug)
          .then((response) => (window.location.href = response.url))
          .finally(() => setIsLoading(false))
      }}
    />
  )
}

export type BillingPortalButtonType = {
  BillingPortalButton: typeof BillingPortalButton
}
